import React from 'react';
import { 
  Box,
  Container,
  Grid,
  Link,
  Typography,
  Divider,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: theme.spacing(6, 0),
    marginTop: 'auto',
  },
  link: {
    color: theme.palette.common.white,
    fontWeight: 500,
    '&:hover': {
      color: theme.palette.secondary.light,
      textDecoration: 'none',
    },
  },
  divider: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    margin: theme.spacing(3, 0),
  },
  copyright: {
    opacity: 0.8,
    fontSize: '0.9rem',
  },
}));

const Footer = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const footerLinks = [
    {
      title: 'Terms of Service',
      url: 'https://docs.google.com/document/d/1xkG8ccYOo9-h1TdRxQP6MEkWzo4UotttVusHba8h2sU/edit',
    },
    {
      title: 'Privacy Policy',
      url: 'https://docs.google.com/document/d/1YsQbDrYkuke9pX13NmyYDcb9l9kc7qe0wakAvKBeCJ8/edit',
    },
    {
      title: 'Disclaimer',
      url: 'https://docs.google.com/document/d/1YsQbDrYkuke9pX13NmyYDcb9l9kc7qe0wakAvKBeCJ8/edit',
    },
  ];

  return (
    <footer className={classes.footer}>
      <Container maxWidth="lg">
        {/* Footer Links */}
        <Grid container justifyContent="center" spacing={isMobile ? 2 : 4}>
          {footerLinks.map((link, index) => (
            <Grid item key={index}>
              <Link
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
                variant="body1"
              >
                {link.title}
              </Link>
            </Grid>
          ))}
        </Grid>

        <Divider className={classes.divider} />

        {/* Copyright */}
        <Box textAlign="center">
          <Typography variant="body2" className={classes.copyright}>
            {'Copyright © '}
            <Link 
              href="https://tradingandcoffee.com/" 
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Trading & Coffee
            </Link>{' '}
            {new Date().getFullYear()}
          </Typography>
        </Box>
      </Container>
    </footer>
  );
};

export default Footer;